/**
 * The list of media screen sizes for different image sizes
 * */
export const SIZES_FOR_SCREENS = [
	{ width: 480, maxWidth: 600 },
	{ width: 800, maxWidth: 1080 },
	{ width: 1280 },
]
